//src/pages/NovoUsuario.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../axiosConfig";
import ComProtecao from "../components/ComProtecao";
import {
  ArrowLeft,
  CheckCircle2,
  Lock,
  Mail,
  Save,
  ShieldCheck,
  UserPlus,
} from "lucide-react";

import "./NovoUsuario.css";

import { validarSenhaFrontend } from "../utils/senhaUtils";

function NovoUsuarioConteudo() {
  const navigate = useNavigate();

  const [usuario, setUsuario] = useState({
    nome: "",
    email: "",
    senha: "",
    tipo: "admin",
    status: "ativo",
  });

  const [salvando, setSalvando] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUsuario((prev) => ({ ...prev, [name]: value }));
  };

  const handleSalvar = async () => {
  const validacaoSenha = validarSenhaFrontend(usuario.senha);

  if (!validacaoSenha.valida) {
    alert(validacaoSenha.mensagem);
    return;
  }

  try {
    setSalvando(true);
    await axios.post("/usuarios/novo", usuario);
    navigate("/usuarios");
  } catch (err) {
    console.error("Erro ao salvar usuário:", err);
    alert(
      err.response?.data?.error ||
      "Erro ao salvar usuário."
    );
  } finally {
    setSalvando(false);
  }
};

  return (
    <div className="novoUsuarioAdmin-page">
      <div className="novoUsuarioAdmin-topbar">
        <div>
          <span className="novoUsuarioAdmin-kicker">Área administrativa</span>
          <h2>Novo usuário</h2>
          <p>
            Cadastre um novo usuário administrativo e defina o tipo de acesso
            inicial ao painel Tikpontos.
          </p>
        </div>

        <button
          type="button"
          className="novoUsuarioAdmin-btn secondary"
          onClick={() => navigate("/usuarios")}
        >
          <ArrowLeft size={16} />
          Voltar para usuários
        </button>
      </div>

      <div className="novoUsuarioAdmin-card">
        <div className="novoUsuarioAdmin-cardHeader">
          <div className="novoUsuarioAdmin-icon">
            <UserPlus size={20} />
          </div>

          <div>
            <h3>Dados do usuário</h3>
            <span>Preencha as informações de acesso administrativo.</span>
          </div>
        </div>

        <div className="novoUsuarioAdmin-form">
          <div className="novoUsuarioAdmin-field full">
            <label>Nome</label>
            <div className="novoUsuarioAdmin-inputIcon">
              <UserPlus size={15} />
              <input
                name="nome"
                value={usuario.nome}
                onChange={handleChange}
                placeholder="Nome completo"
              />
            </div>
          </div>

          <div className="novoUsuarioAdmin-field full">
            <label>E-mail</label>
            <div className="novoUsuarioAdmin-inputIcon">
              <Mail size={15} />
              <input
                name="email"
                type="email"
                value={usuario.email}
                onChange={handleChange}
                placeholder="email@dominio.com.br"
              />
            </div>
          </div>

          <div className="novoUsuarioAdmin-field full">
            <label>Senha</label>
            <div className="novoUsuarioAdmin-inputIcon">
              <Lock size={15} />
              <input
                type="password"
                name="senha"
                value={usuario.senha}
                onChange={handleChange}
                placeholder="Senha inicial do usuário"
              />
            </div>
          </div>

          <div className="novoUsuarioAdmin-field">
            <label>Tipo de usuário</label>
            <select name="tipo" value={usuario.tipo} onChange={handleChange}>
              <option value="admin">Admin</option>
              <option value="financeiro">Financeiro</option>
              <option value="comercial">Comercial</option>
              <option value="logistica">Logística</option>
            </select>
          </div>

          <div className="novoUsuarioAdmin-field">
            <label>Status</label>
            <select name="status" value={usuario.status} onChange={handleChange}>
              <option value="ativo">Ativo</option>
              <option value="inativo">Inativo</option>
            </select>
          </div>
        </div>

        <div className="novoUsuarioAdmin-info">
          <ShieldCheck size={16} />
          <span>
            As permissões detalhadas podem ser configuradas depois, na área de
            usuários do sistema.
          </span>
        </div>

        <div className="novoUsuarioAdmin-actions">
          <button
            type="button"
            className="novoUsuarioAdmin-btn secondary"
            onClick={() => navigate("/usuarios")}
          >
            <ArrowLeft size={16} />
            Voltar
          </button>

          <button
            type="button"
            className="novoUsuarioAdmin-btn primary"
            onClick={handleSalvar}
            disabled={salvando}
          >
            {salvando ? (
              <>
                <CheckCircle2 size={16} />
                Salvando...
              </>
            ) : (
              <>
                <Save size={16} />
                Salvar usuário
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function NovoUsuario() {
  return (
    <ComProtecao rota="usuarios" tipo="pode_inserir">
      <NovoUsuarioConteudo />
    </ComProtecao>
  );
}